/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdminActivityDetailParticipantsSectionDto } from './adminActivityDetailParticipantsSectionDto';
import { GetAdminActivityDetailResponseGroup } from './getAdminActivityDetailResponseGroup';
import { AdminActivityDetailUserDto } from './adminActivityDetailUserDto';
import { AdminGroupListSportDto } from './adminGroupListSportDto';
import { AdminActivityDetailScheduleDto } from './adminActivityDetailScheduleDto';
import { AdminDeletionDto } from './adminDeletionDto';
import { AdminActivityDetailLevelDto } from './adminActivityDetailLevelDto';


export interface GetAdminActivityDetailResponse { 
    id: string;
    title: string;
    /**
     * Activity creation date as ISO string.
     */
    createdAt: string;
    backgroundUrl?: string;
    description: string;
    privacy: GetAdminActivityDetailResponse.PrivacyEnum;
    /**
     * External route URL associated with the activity.
     */
    routeUrl?: string;
    handiFriendly?: boolean;
    sport: AdminGroupListSportDto;
    level: AdminActivityDetailLevelDto;
    schedule: AdminActivityDetailScheduleDto;
    creator: AdminActivityDetailUserDto;
    group?: GetAdminActivityDetailResponseGroup | null;
    participants: AdminActivityDetailParticipantsSectionDto;
    status: GetAdminActivityDetailResponse.StatusEnum;
    /**
     * Event pricing type.
     */
    type?: string;
    deletion?: AdminDeletionDto;
}
export namespace GetAdminActivityDetailResponse {
    export type PrivacyEnum = 'public' | 'private' | 'members_only';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        MembersOnly: 'members_only' as PrivacyEnum
    };
    export type StatusEnum = 'scheduled' | 'finished' | 'cancelled';
    export const StatusEnum = {
        Scheduled: 'scheduled' as StatusEnum,
        Finished: 'finished' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


